import { Button } from "@/components/elements/Button";
import { AppRoutes } from "@/routes/config";
import { text } from "@/theme/colors";
import { logout } from "@/utils/logout";
import { Paper, Stack, Typography, styled } from "@mui/material";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

export const ResetPasswordSuccessForm = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const email = (location.state as { email?: string } | null)?.email;

  if (!email) {
    return <Navigate to={AppRoutes.pageNotFound} replace />;
  }

  // Await logout BEFORE navigating so /login's withGuest doesn't race a stale
  // session (a still-logged-in admin) and bounce into the admin area.
  const handleGoToLogin = async () => {
    await logout();
    navigate(`${AppRoutes.login}?email=${encodeURIComponent(email)}`, { replace: true });
  };

  return (
    <Container
      elevation={0}
      sx={{
        width: 464,
        p: 4,
        borderRadius: "16px",
      }}
    >
      <Stack gap={3}>
        <Typography variant="head20Bold" color={text.primary} textAlign="center">
          パスワード再発行完了
        </Typography>
        <Typography variant="body14" fontSize="14px" color={text.secondary} mt={1} mb="12px">
          パスワードの再発行が完了いたしました。
          <br />
          パスワードの再発行完了メールをご登録されているメールアドレス宛に送信いたしました。
        </Typography>
        <Stack mt={1}>
          <Button size="sm" variant="primary" fullWidth onClick={handleGoToLogin}>
            <Typography variant="body14Semi">ログイン画面へ</Typography>
          </Button>
        </Stack>
      </Stack>
    </Container>
  );
};

const Container = styled(Paper)`
  box-shadow:
    0 4px 4px -1px rgba(12, 12, 13, 0.05),
    0 4px 4px -1px rgba(12, 12, 13, 0.1) !important;
`;
